import React from "react";

type Props = { size?: number }; // size in px, preserves viewBox scaling

export default function GoogleLogo({ size = 18 }: Props) {
  return (
    <svg
      width={size} // control icon size
      height={size} // control icon size
      viewBox="0 0 28 28" // adjusted to better fit the actual logo content
      aria-hidden="true" // decorative icon in a labeled button
      focusable="false"
    >
      <g>
        <path
          fill="#EA4335"
          d="M27.985 14.262c0-1.147-.095-1.984-.301-2.853H14.279v5.178h7.868c-.158 1.287-1.015 3.225-2.919 4.527l-.026.173 4.238 3.209.294.028c2.696-2.434 4.251-6.015 4.251-10.262Z"
        />
        <path
          fill="#FBBC05"
          d="M14.28 27.904c3.854 0 7.09-1.24 9.454-3.38l-4.505-3.41c-1.206.822-2.824 1.395-4.95 1.395a8.577 8.577 0 0 1-8.122-5.798l-.168.014-4.407 3.333-.058.157c2.348 4.557 7.17 7.689 12.755 7.689Z"
        />
        <path
          fill="#34A853"
          d="M6.157 16.711a8.412 8.412 0 0 1-.476-2.76c0-.96.174-1.89.46-2.758l-.008-.185L1.67 7.62l-.146.068a13.706 13.706 0 0 0-1.523 6.263c0 2.248.556 4.371 1.523 6.263l4.633-3.504Z"
        />
        <path
          fill="#4285F4"
          d="M14.279 5.395c2.68 0 4.49 1.131 5.52 2.077l4.03-3.845C21.354 1.38 18.134 0 14.279 0 8.695 0 3.872 3.131 1.524 7.689l4.617 3.504a8.613 8.613 0 0 1 8.138-5.798Z"
        />
      </g>
    </svg>
  );
}
